var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-button",
    {
      staticClass:
        "center-element vk-button align-items-center mt-3 position-relative",
      style: _vm.buttonStyle,
      attrs: { href: `${_vm.link}&usage=${_vm.usage}` },
    },
    [
      _c("img", {
        staticClass: "social-icon",
        style: _vm.iconStyle,
        attrs: { src: require("../assets/images/socialIcons/vk.svg") },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex align-items-center", style: _vm.iconTextStyle },
        [_vm._v("\n        " + _vm._s(_vm.buttonText) + "\n    ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }